export const DATE_BUTTONS = [
  {
    dateRangeValue: 1,
    dateRangeTitle: '本日',
    isChoosed: false,
    index: 0
  },{
    dateRangeValue: 2,
    dateRangeTitle: '本周',
    isChoosed: false,
    index: 1
  },{
    dateRangeValue: 3,
    dateRangeTitle: '本月',
    isChoosed: false,
    index: 2
  },{
    dateRangeValue: 4,
    dateRangeTitle: '本季',
    isChoosed: false,
    index: 3
  },{
    dateRangeValue: 5,
    dateRangeTitle: '本年',
    isChoosed: false,
    index: 4
  }
  // ,{
  //   dateRangeValue: -1,
  //   dateRangeTitle: '自定义',
  //   isChoosed: false,
  //   index: 5
  // }
];
